import { Container, Title, Text, Stack, Grid, Paper } from '@mantine/core';
import { EmployeeGenerator } from './components/EmployeeGenerator';
import { ShiftConditions } from './components/ShiftConditions';
import { ShiftSchedule } from './components/ShiftSchedule';

export function App() {
  return (
    <Container size="xl" py="md">
      <Stack gap="lg">
        {/* ヘッダー */}
        <Paper p="md" withBorder>
          <Stack gap="xs">
            <Title order={1} size="h2">
              シフト作成デモ
            </Title>
            <Text c="dimmed">
              製造ライン A〜E の 2交代制シフトを自動最適化
            </Text>
          </Stack>
        </Paper>

        {/* メインコンテンツ */}
        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            {/* 従業員管理セクション */}
            <Stack gap="md">
              <EmployeeGenerator />
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            {/* シフト条件セクション */}
            <Stack gap="md">
              <ShiftConditions />
            </Stack>
          </Grid.Col>

          <Grid.Col span={12}>
            {/* シフト表セクション */}
            <ShiftSchedule />
          </Grid.Col>
        </Grid>
      </Stack>
    </Container>
  );
}